import React from 'react';

import { Typography } from '@material-ui/core';

import { t } from '~/helpers';

import * as S from './styles';

export default function Loading() {
  return (
    <S.Wrapper>
      <Typography>{'Aguarde! Atualizando dados do turno...'}</Typography>
      <S.WrapperLoading />
    </S.Wrapper>
  );
}
